
import React from "react";
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import './toggleView.css';
import PropTypes from "prop-types";

export class ToggleView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status:this.props.status
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.status !== this.props.status) {
            this.setState({
                status: this.props.status
            });
        }
    }


    render() {
        return <label>
        <Toggle
          checked={this.state.status}
          className='custom-toggle'
          icons={false}
          onChange={(value)=>{this.props.onStatusChange(value.target.checked,this.props.masterData)}}
         />
      </label>
    }
}

ToggleView.propTypes = {
  status: PropTypes.bool,
  onStatusChange: PropTypes.func,
  masterData: PropTypes.any,
};